import { FirebaseActions } from '@web_opxp/features';

export const trackGoToBlogButton = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'go_to_blog_from_preview_link' });
